import { createGlobalStyle } from 'styled-components';
import styledNormalize from 'styled-normalize';

const GlobalStyle = createGlobalStyle`
${styledNormalize}

* {
  &,
  &:before,
  &:after {
    box-sizing: border-box;
  }
}

body {
  margin: 0;
  padding: 0;
  font-family: 'GT Walsheim', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#seoManualContent {
  p, li, a {
    word-break: break-word !important;
  }
}
`;

export default GlobalStyle;
